import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

const OfferSlider = () => {
  const [offers, setOffers] = useState([]);
  const [current, setCurrent] = useState(0);

  // Fetch offers from API
  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_SERVER_DOMIN}/offers?limit=10`);
        const data = await res.json();
        setOffers(data.offers || []);
      } catch (err) {
        console.error("❌ Fetch Offers Error:", err);
        toast.error("Failed to fetch offers");
      }
    };
    fetchOffers();
  }, []);

  // Auto-slide every 3 seconds
  useEffect(() => {
    if (offers.length <= 1) return;
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % offers.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [offers]);

  if (!offers || offers.length === 0) return null;

  return (
    <div className="relative w-full h-64 md:h-96 overflow-hidden rounded-3xl shadow-lg">
      {offers.map((offer, index) => (
        <img
          key={index}
          src={offer.image} // assuming your offer document has an `image` field
          alt={offer.title || `Offer ${index + 1}`}
          className={`w-full h-full object-cover absolute top-0 left-0 transition-opacity duration-700 ${
            index === current ? "opacity-100" : "opacity-0"
          }`}
        />
      ))}

      {/* Navigation dots */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
        {offers.map((_, index) => (
          <span
            key={index}
            className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
              index === current ? "bg-pink-400" : "bg-gray-300"
            }`}
            onClick={() => setCurrent(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default OfferSlider;
